<template>
  <router-view />
  <router-view v-slot="{ Component }" name="slideIn">
    <transition
      enter-active-class="duration-300 ease-out"
      enter-from-class="translate-x-full"
      leave-active-class="duration-200 ease-in"
      leave-to-class="translate-x-full"
    >
      <component :is="Component" />
    </transition>
  </router-view>
  <router-view name="dialog" />
</template>
